export const LEVEL_RANKS = [
  { level:1, min:1, max:1, name:'微光', icon:'Lv.1', gradient:'linear-gradient(135deg,#E8F4FC,#B8D4E8,#A0C4E8)' },
  { level:2, min:2, max:2, name:'星火', icon:'Lv.2', gradient:'linear-gradient(135deg,#2ECC71,#27AE60,#1ABC9C)' },
  { level:3, min:3, max:3, name:'行星', icon:'Lv.3', gradient:'linear-gradient(135deg,#FF6B6B,#FFA07A,#FFD700)' },
  { level:4, min:4, max:4, name:'恒星', icon:'Lv.4', gradient:'linear-gradient(135deg,#9B59B6,#8E44AD,#6C3483)' },
  { level:5, min:5, max:5, name:'星团', icon:'Lv.5', gradient:'linear-gradient(135deg,#1ABC9C,#16A085,#0E6655)' },
  { level:6, min:6, max:6, name:'星系', icon:'Lv.6', gradient:'linear-gradient(135deg,#3498DB,#2980B9,#1F618D)' },
  { level:7, min:7, max:7, name:'星云', icon:'Lv.7', gradient:'linear-gradient(135deg,#E74C3C,#C0392B,#922B21)' },
  { level:8, min:8, max:8, name:'星海', icon:'Lv.8', gradient:'linear-gradient(135deg,#F39C12,#E67E22,#D4AC0E)' },
  { level:9, min:9, max:9, name:'银河', icon:'Lv.9', gradient:'linear-gradient(135deg,#48C9B0,#1ABC9C,#0E6655)' },
  { level:10, min:10, max:10, name:'星域', icon:'Lv.10', gradient:'linear-gradient(135deg,#FF69B4,#FFB6C1,#FFF0F5)' },
  { level:11, min:11, max:11, name:'宇宙', icon:'Lv.11', gradient:'linear-gradient(135deg,#87CEEB,#B0E0E6,#E0FFFF)' },
  { level:12, min:12, max:12, name:'无限', icon:'Lv.12', gradient:'linear-gradient(135deg,#0F0C29,#302B63,#764BA2)', animated:true },
];

export const LEVEL_XP_THRESHOLDS = [0, 100, 400, 1000, 2000, 4000, 7500, 13000, 21000, 33000, 51000, 77000];
export const MAX_LEVEL = LEVEL_XP_THRESHOLDS.length;

export function levelFromXp(xp) {
  const value = Math.max(0, Number(xp) || 0);
  let level = 1;
  for (let i = 1; i < LEVEL_XP_THRESHOLDS.length; i++) {
    if (value >= LEVEL_XP_THRESHOLDS[i]) level = i + 1;
    else break;
  }
  return level;
}

export function getLevelXpInfo(xp) {
  const value = Math.max(0, Number(xp) || 0);
  const level = levelFromXp(value);
  const currentStart = LEVEL_XP_THRESHOLDS[level - 1] || 0;
  const nextStart = LEVEL_XP_THRESHOLDS[level] ?? null;
  const xpIntoLevel = value - currentStart;
  const xpForNext = nextStart === null ? 0 : nextStart - currentStart;
  const xpNeeded = nextStart === null ? 0 : Math.max(0, nextStart - value);
  const percent = nextStart === null ? 100 : Math.max(0, Math.min(100, Math.round((xpIntoLevel / xpForNext) * 100)));
  return { level, currentStart, nextStart, xp: value, xpIntoLevel, xpForNext, xpNeeded, percent, isMax: nextStart === null };
}

export function getLevelRank(level) {
  const safeLevel = Math.max(1, Math.min(MAX_LEVEL, level || 1));
  return LEVEL_RANKS.find(r => r.level === safeLevel) || LEVEL_RANKS[0];
}

export const LEVEL_BENEFITS = {
  avatarFrames: {
    1:  { id:'frame_default',      name:'默认边框',   color:'#4a6b8a', pattern:'default',     requireLevel:1 },
    2:  { id:'frame_beta_test',   name:'内测纪念头像框', color:'#4DD0E1', pattern:'beta',
          background:'linear-gradient(135deg, rgba(77,208,225,0.95) 0%, rgba(96,132,255,0.9) 50%, rgba(179,136,255,0.95) 100%)',
          shadow:'0 0 14px rgba(77,208,225,0.42), inset 0 0 8px rgba(77,208,225,0.22)',
          requireLevel:0, special:true, specialSource:'内测签到7天' },
  },
  chatFrames: {
    1:  { id:'chat_default',    name:'默认聊天框',   color:'#1b2838', pattern:'default',      requireLevel:1 },
    2:  { id:'chat_beta_test',  name:'内测纪念聊天框', color:'#4DD0E1', pattern:'beta',
          background:'linear-gradient(135deg, rgba(18,55,74,0.97) 0%, rgba(45,48,95,0.97) 52%, rgba(65,43,94,0.97) 100%)',
          shadow:'0 0 14px rgba(77,208,225,0.3), inset 0 0 10px rgba(179,136,255,0.1)',
          requireLevel:0, special:true, specialSource:'内测全服50人参与' },
  },
  badges:{},
  coupons:{},
  privileges:{},
  backgrounds: {
    1:  { id:'bg_default',     name:'默认深空',   style:'linear-gradient(135deg,#0d1621 0%,#1b3a5c 50%,#0d1621 100%)',           requireLevel:1 },
    2:  { id:'bg_esports',     name:'霓虹夜',     style:'linear-gradient(135deg,#0a0a1a 0%,#0d1b2e 40%,#1a1a2e 100%)',           requireLevel:6 },
    3:  { id:'bg_stage',       name:'聚光灯',     style:'linear-gradient(135deg,#1a0a0a 0%,#2e0d0d 40%,#1a0a0a 100%)',           requireLevel:7 },
    4:  { id:'bg_gold',        name:'黄金殿',     style:'linear-gradient(135deg,#1a140a 0%,#2e1b0d 40%,#4a280d 100%)',           requireLevel:8, animated:true },
    5:  { id:'bg_diamond',     name:'钻石之地',   style:'linear-gradient(135deg,#0a0a14 0%,#1a0a2e 40%,#2a1a4a 100%)',           requireLevel:9, animated:true, canvas:true },
    6:  { id:'bg_pinkcloud',   name:'糖心云',     style:'linear-gradient(135deg,#1a0a14 0%,#2e0d1b 40%,#4a1a28 100%)',           requireLevel:10, animated:true, canvas:true },
    7:  { id:'bg_skycloud',    name:'云端梦境',   style:'linear-gradient(135deg,#0a141f 0%,#1a2842 40%,#2d4a6e 100%)',           requireLevel:11, animated:true, canvas:true },
    8:  { id:'bg_cosmic',      name:'无限宇宙',   style:'linear-gradient(135deg,#000000 0%,#0F0C29 30%,#302B63 60%,#764BA2 100%)', requireLevel:12, animated:true, canvas:true },
  },
};

export function getSafeBackground(bgId) {
  const fallback = { id:'bg_default', name:'默认深空', style:'linear-gradient(135deg,#0d1621 0%,#1b3a5c 50%,#0d1621 100%)' };
  if (!bgId) return fallback;
  return LEVEL_BENEFITS.backgrounds[bgId] || fallback;
}

export function getUnlockedBenefits(level, user) {
  const benefits = { avatarFrames:[], chatFrames:[], badges:[], coupons:[], privileges:[], backgrounds:[] };
  /* 活动限定框（special）不属于等级权益，不能按等级算作已解锁 */
  Object.entries(LEVEL_BENEFITS.avatarFrames).forEach(([lv,f]) => { if(!f.special && level>=parseInt(lv)) benefits.avatarFrames.push({...f}); });
  Object.entries(LEVEL_BENEFITS.chatFrames).forEach(([lv,f]) => {
    if (f.special ? getOwnedSpecialFrames(user).has(f.id) : level>=parseInt(lv)) benefits.chatFrames.push({...f});
  });
  Object.entries(LEVEL_BENEFITS.badges).forEach(([lv,b]) => { if(level>=parseInt(lv)) benefits.badges.push({...b}); });
  Object.entries(LEVEL_BENEFITS.coupons).forEach(([lv,c]) => { if(level>=parseInt(lv)) benefits.coupons.push({...c}); });
  Object.entries(LEVEL_BENEFITS.privileges).forEach(([lv,p]) => { if(level>=parseInt(lv)) benefits.privileges.push({...p}); });
  Object.entries(LEVEL_BENEFITS.backgrounds).forEach(([lv,b]) => { if(level>=parseInt(lv) && level>=(b.requireLevel||0)) benefits.backgrounds.push({...b}); });
  return benefits;
}

/* 等级只由经验值决定。
   原来的「年资升级（满 1 年 +1 级）」「消费升级（每 1 万元 +1 级）」已彻底下线，
   连计算函数一起删掉——留着只会让页面显示和 XP 表对不上。 */

/* 头像框视觉：优先使用框自带的 background / shadow，
   没有配置时才退回纯色 + 同色阴影（老逻辑）。
   这样限定框可以是渐变玻璃质感，而不是一块刺眼的纯色。 */
export function getFrameVisual(frameId) {
  const frame = Object.values(LEVEL_BENEFITS.avatarFrames).find(f => f.id === frameId);
  if (!frame) return {};
  return {
    background: frame.background || frame.color,
    boxShadow: frame.shadow || `0 4px 20px ${frame.color}66`,
  };
}

/* 已拥有的限定框：只要服务端返回了 purchasedFrames（包括空数组），就以它为准。
   本地 specialFrames 仅用于旧版登录信息尚未刷新时的短暂兼容，不能再覆盖服务端空记录。 */
export function getOwnedSpecialFrames(user) {
  let server = user?.purchasedFrames;
  if (typeof server === 'string') {
    try { server = JSON.parse(server); } catch(e) { server = []; }
  }
  if (Array.isArray(server)) return new Set(server);

  const owned = new Set();
  try {
    const local = JSON.parse(localStorage.getItem(`specialFrames_${user?.id}`) || '[]');
    if (Array.isArray(local)) local.forEach(f => owned.add(f));
  } catch(e) {}
  return owned;
}

/* 是否拥有某个头像框：限定框看拥有记录，普通框看等级。 */
export function isAvatarFrameOwned(frame, user, userLevel) {
  if (!frame) return false;
  if (frame.special) return getOwnedSpecialFrames(user).has(frame.id);
  return (userLevel || 1) >= (frame.requireLevel || 1);
}

/* 聊天框与头像框共用服务端拥有记录，但物品编号和装备字段各自独立。 */
export function isChatFrameOwned(frame, user, userLevel) {
  if (!frame) return false;
  if (frame.special) return getOwnedSpecialFrames(user).has(frame.id);
  return (userLevel || 1) >= (frame.requireLevel || 1);
}
